import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=0d69dd1c"
import script from "./imgs.vue?vue&type=script&lang=js"
export * from "./imgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports